// import {FormLabel, Option, Select, useColorScheme} from "@mui/joy";
import {FormControl, InputLabel, MenuItem, Select, useColorScheme as materialColorScheme} from '@mui/material'
import {useColorScheme} from '@mui/joy'
import React from "react";

export const ThemeSelector = () => {
    const materialMode = materialColorScheme();
    const joyMode = useColorScheme();
    const {mode} = materialMode

    const changeModeHandler = (newMode: "light" | "dark" | "system" | null) => {
        materialMode.setMode(newMode);
        joyMode.setMode(newMode)
    }

    return (
        <FormControl fullWidth variant={'outlined'}>
            <InputLabel variant={'outlined'}>
                Tema
            </InputLabel>
            <Select
                label="Tema"
                value={mode}
                onChange={(event,) => {
                    changeModeHandler(event.target.value as "light" | "dark" | "system");
                }}>
                <MenuItem value="system">Sistema</MenuItem>
                <MenuItem value="light">Claro</MenuItem>
                <MenuItem value="dark">Escuro</MenuItem>
            </Select>
        </FormControl>
    );
}